export const ImmunohistochemistryTypes= [
    {
      value: '胃癌治疗相关免疫标志物',
      label: '胃癌治疗相关免疫标志物',
      children: [
        {
          value: 'HER2',
          label: 'HER2',
        },
        {
          value: 'EGFR',
          label: 'EGFR',
          
        },
        {
          value: 'MET',
          label: 'MET',
          
        },
        {
          value: 'VEGFR2',
          label: 'VEGFR2',
        
        },
      ],
    },
    {
      value: '胃癌化疗相关免疫标志物',
      label: '胃癌化疗相关免疫标志物',
      children: [
        {
          value: 'KI67',
          label: 'KI67',
        },
        {
          value: '微管蛋白',
          label: '微管蛋白',
          
        },
        {
          value: 'ERCC1',
          label: 'ERCC1',
          
        },
        {
          value: 'TS',
          label: 'TS',
        
        },
      ],
    },
    {
      value: '结直肠癌诊断相关标志物',
      label: '结直肠癌诊断相关标志物',
      children: [
        {
          value: 'CK7、CK20',
          label: 'CK7、CK20',
          
        },
        {
          value: 'CDX2',
          label: 'CDX2',
        },
        {
          value: 'CDH17',
          label: 'CDH17',
        },
      ],
    },
    {
      value: '结直肠癌的分子标志物',
      label: '结直肠癌的分子标志物',
      children: [
        {
          value: 'MSI和错配修复基因',
          label: 'MSI和错配修复基因',
          
        },
        {
          value: 'APC基因',
          label: 'APC基因',
        },
        {
          value: 'RAS',
          label: 'RAS',
          
        },
        {
          value: 'BRAF',
          label: 'BRAF',
        },
        {
          value: 'PI3KCA',
          label: 'PI3KCA',
          
        },
        {
          value: 'HER2',
          label: 'HER2',
        },
        {
          value: 'VEGF',
          label: 'VEGF',
          
        }
      ],
    },
    {
      value: '结直肠癌化疗相关的其他标志物',
      label: '结直肠癌化疗相关的其他标志物',
      children: [
        {
          value: 'Maspin',
          label: 'Maspin',
          
        },
        {
          value: 'UGT1A1',
          label: 'UGT1A1',
        },
        {
          value: 'ERCC1',
          label: 'ERCC1',
          
        },
        {
          value: 'TS',
          label: 'TS',
        },
        {
          value: 'PTEN',
          label: 'PTEN',
          
        },
        {
          value: 'EGFR',
          label: 'EGFR',
        }
      ],
    },
    {
      value: '结直肠癌预后相关的标志物',
      label: '结直肠癌预后相关的标志物',
      children: [
        {
          value: 'MET',
          label: 'MET',
          
        },
        {
          value: 'K-ras',
          label: 'K-ras',
        }
      ],
    },
  ]